import type { ServiceOfferingShopCategory } from '@freelancer/datastore/collections';

export interface CategoryServiceActionOptions {
  remove: boolean;
  toggleVisibility: boolean;
  edit: boolean;
  drag: boolean;
}

export const defaultActionOptions = {
  remove: false,
  toggleVisibility: false,
  edit: false,
  drag: false,
};

export interface CarouselHeaderFormType {
  name: string;
  description: string;
}

export interface CategorySaveEvent {
  category?: ServiceOfferingShopCategory;
  updates: CarouselHeaderFormType;
}
